// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.receipt-pdf {
  width: 100%;
  min-height: 100vh;
  background: white;
  padding: 20px;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
}
.receipt-pdf .receipt-header,
.receipt-pdf .receipt-footer {
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}
.receipt-pdf .receipt-header {
  margin-bottom: 20px;
}
.receipt-pdf .receipt-footer {
  margin-top: auto;
  margin-bottom: 0;
}
.receipt-pdf .company-name {
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}
.receipt-pdf .receipt-title {
  text-align: center;
  margin-bottom: 30px;
}
.receipt-pdf .receipt-title h1 {
  font-size: 24px;
  font-weight: bold;
  color: #004A9A;
  margin: 0;
  padding: 10px;
  border: 2px solid #004A9A;
  display: inline-block;
  letter-spacing: 2px;
}
.receipt-pdf .receipt-details-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 30px;
  width: 100%;
}
.receipt-pdf .receipt-details-container .receipt-info,
.receipt-pdf .receipt-details-container .client-info {
  flex: 1 1;
  max-width: 50%;
}
.receipt-pdf .receipt-details-container .receipt-info h3,
.receipt-pdf .receipt-details-container .client-info h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  border-bottom: 2px solid #004A9A;
  padding-bottom: 5px;
  width: 100%;
}
.receipt-pdf .receipt-details-container .receipt-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 15px;
  margin-right: 0;
}
.receipt-pdf .receipt-details-container .client-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 15px;
  margin-left: 0;
  min-width: 0;
}
.receipt-pdf .receipt-details-container .client-info h3 {
  text-align: left;
}
.receipt-pdf .receipt-details-container .client-info p {
  width: 100%;
  word-wrap: break-word;
}
.receipt-pdf .payment-details-section {
  margin: 20px 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.receipt-pdf .payment-details-section h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #004A9A;
  border-bottom: 2px solid #004A9A;
  padding-bottom: 5px;
}
.receipt-pdf .payment-details-section .payment-details-table {
  width: 100%;
  border-collapse: collapse;
}
.receipt-pdf .payment-details-section .payment-details-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}
.receipt-pdf .payment-details-section .payment-details-table td:first-child {
  width: 40%;
  background-color: #f5f5f5;
  font-weight: 500;
}
.receipt-pdf .payment-details-section .payment-details-table td:last-child {
  width: 60%;
}
.receipt-pdf .payment-details-section .payment-details-table td.amount-cell {
  font-weight: bold;
  color: #004A9A;
  font-size: 16px;
}
.receipt-pdf .payment-details-section .payment-details-table tr:last-child td {
  border-bottom: none;
}
.receipt-pdf .invoice-summary {
  margin: 20px 0;
  border: 1px solid #004A9A;
  border-radius: 8px;
  background-color: #f0f7ff;
}
.receipt-pdf .invoice-summary h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #004A9A;
  border-bottom: 2px solid #004A9A;
  padding-bottom: 5px;
}
.receipt-pdf .invoice-summary .invoice-summary-table {
  width: 100%;
  border-collapse: collapse;
}
.receipt-pdf .invoice-summary .invoice-summary-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #ddd;
  font-size: 14px;
}
.receipt-pdf .invoice-summary .invoice-summary-table td:first-child {
  width: 60%;
  font-weight: 500;
}
.receipt-pdf .invoice-summary .invoice-summary-table td:last-child {
  width: 40%;
  text-align: right;
}
.receipt-pdf .invoice-summary .invoice-summary-table td.amount-cell {
  font-weight: bold;
  color: #004A9A;
  font-size: 16px;
}
.receipt-pdf .invoice-summary .invoice-summary-table tr:last-child td {
  border-bottom: none;
  font-weight: bold;
  background-color: #004A9A;
  color: white;
}
.receipt-pdf .invoice-summary .invoice-summary-table tr:last-child td.amount-cell {
  color: white;
}
.receipt-pdf .amount-in-words {
  margin: 20px 0;
  padding: 15px;
  background-color: #f5f5f5;
  border-left: 4px solid #004A9A;
  font-style: italic;
}
.receipt-pdf .amount-in-words p {
  margin: 0;
  font-size: 14px;
}
.receipt-pdf .bank-details {
  margin: 15px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.receipt-pdf .bank-details strong {
  display: block;
  margin-bottom: 5px;
  font-size: 16px;
  color: #004A9A;
}
.receipt-pdf .bank-details p {
  margin: 5px 0;
  line-height: 1.6;
}
.receipt-pdf .receipt-footer-section {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.receipt-pdf .receipt-footer-section .signature {
  text-align: left;
  flex: 1 1;
}
.receipt-pdf .receipt-footer-section .signature img {
  width: 150px;
  height: auto;
  margin-bottom: 10px;
}
.receipt-pdf .receipt-footer-section .signature p {
  margin: 0;
  font-size: 12px;
  font-style: italic;
  color: #666;
}
.receipt-pdf .receipt-footer-section .generated-info {
  text-align: right;
  flex: 1 1;
}
.receipt-pdf .receipt-footer-section .generated-info p {
  margin: 5px 0;
  font-size: 12px;
  color: #666;
}
.receipt-pdf .receipt-footer-section .generated-info p:last-child {
  font-weight: bold;
  color: #004A9A;
  font-size: 14px;
}
.receipt-pdf .receipt-info p,
.receipt-pdf .client-info p,
.receipt-pdf .bank-details p {
  margin: 4px 0;
  font-size: 14px;
}
.receipt-pdf .receipt-info p strong,
.receipt-pdf .client-info p strong,
.receipt-pdf .bank-details p strong {
  font-weight: bold;
}
@media print {
  .receipt-pdf {
    width: 100%;
    margin: 0;
    padding: 20px;
  }
  .receipt-pdf .receipt-header,
  .receipt-pdf .receipt-footer {
    max-width: 100%;
    page-break-inside: avoid;
  }
  .receipt-pdf .payment-details-section,
  .receipt-pdf .invoice-summary,
  .receipt-pdf .bank-details,
  .receipt-pdf .receipt-footer-section {
    page-break-inside: avoid;
  }
  .receipt-pdf .receipt-details-container {
    page-break-inside: avoid;
  }
}
@media (max-width: 768px) {
  .receipt-pdf .receipt-details-container {
    flex-direction: column;
    gap: 20px;
  }
  .receipt-pdf .receipt-details-container .receipt-info {
    padding-right: 0;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 15px;
  }
  .receipt-pdf .receipt-details-container .client-info {
    padding-left: 0;
    padding-top: 15px;
  }
  .receipt-pdf .receipt-footer-section {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .receipt-pdf .receipt-footer-section .signature,
  .receipt-pdf .receipt-footer-section .generated-info {
    text-align: center;
  }
}
.receipt-pdf * {
  box-sizing: border-box;
}
.receipt-pdf p,
.receipt-pdf div,
.receipt-pdf section {
  orphans: 2;
  widows: 2;
}
.receipt-pdf .receipt-info,
.receipt-pdf .client-info,
.receipt-pdf .payment-details-section,
.receipt-pdf .invoice-summary,
.receipt-pdf .bank-details,
.receipt-pdf .receipt-footer-section {
  page-break-inside: avoid;
}

.req-pad {
  padding: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/RecieptPDFTemplate/ReceiptPDFTemplate.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAEE;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;AAFJ;AAME;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAJJ;AAQE;EACE,kBAAA;EACA,mBAAA;AANJ;AAQI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AANN;AAWE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AATJ;AAWI;;EAEE,SAAA;EACA,cAAA;AATN;AAWM;;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;AARR;AAYI;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAVN;AAaI;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAXN;AAaM;EACE,gBAAA;AAXR;AAcM;EACE,WAAA;EACA,qBAAA;AAZR;AAkBE;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAhBJ;AAkBI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,WAAA;EACA,yBAAA;AAjBN;AAmBM;EACE,iBAAA;EACA,6BAAA;EACA,eAAA;AAjBR;AAmBQ;EACE,UAAA;EACA,yBAAA;EACA,gBAAA;AAjBV;AAoBQ;EACE,UAAA;AAlBV;AAqBQ;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAnBV;AAuBM;EACE,mBAAA;AArBR;AA2BE;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAzBJ;AA2BI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AAzBN;AA4BI;EACE,WAAA;EACA,yBAAA;AA1BN;AA4BM;EACE,kBAAA;EACA,6BAAA;EACA,eAAA;AA1BR;AA4BQ;EACE,UAAA;EACA,gBAAA;AA1BV;AA6BQ;EACE,UAAA;EACA,iBAAA;AA3BV;AA8BQ;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AA5BV;AAgCM;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AA9BR;AAgCQ;EACE,YAAA;AA9BV;AAqCE;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;AAnCJ;AAqCI;EACE,SAAA;EACA,eAAA;AAnCN;AAwCE;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAtCJ;AAwCI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAtCN;AAyCI;EACE,aAAA;EACA,gBAAA;AAvCN;AA4CE;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AA1CJ;AA4CI;EACE,gBAAA;EACA,SAAA;AA1CN;AA4CM;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AA1CR;AA6CM;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AA3CR;AA+CI;EACE,iBAAA;EACA,SAAA;AA7CN;AA+CM;EACE,aAAA;EACA,eAAA;EACA,WAAA;AA7CR;AA+CQ;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AA7CV;AAoDE;;;EAGE,aAAA;EACA,eAAA;AAlDJ;AAoDI;;;EACE,iBAAA;AAhDN;AAoDE;EAhTF;IAiTI,WAAA;IACA,SAAA;IACA,aAAA;EAjDF;EAmDE;;IAEE,eAAA;IACA,wBAAA;EAjDJ;EAoDE;;;;IAIE,wBAAA;EAlDJ;EAqDE;IACE,wBAAA;EAnDJ;AACF;AAuDE;EACE;IACE,sBAAA;IACA,SAAA;EArDJ;EAuDI;IACE,gBAAA;IACA,gCAAA;IACA,oBAAA;EArDN;EAwDI;IACE,eAAA;IACA,iBAAA;EAtDN;EA0DE;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EAxDJ;EA0DI;;IAEE,kBAAA;EAxDN;AACF;AA6DE;EACE,sBAAA;AA3DJ;AA8DE;;;EAGE,UAAA;EACA,SAAA;AA5DJ;AAgEE;;;;;;EAME,wBAAA;AA9DJ;;AAkEA;EACE,eAAA;AA/DF","sourcesContent":[".receipt-pdf {\n  width: 100%;\n  min-height: 100vh;\n  background: white;\n  padding: 20px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #333;\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  // Header and Footer images\n  .receipt-header,\n  .receipt-footer {\n    width: 100%;\n    height: auto;\n    max-height: 150px;\n    object-fit: contain;\n    display: block;\n    flex-shrink: 0;\n  }\n\n  .receipt-header {\n    margin-bottom: 20px;\n  }\n\n  .receipt-footer {\n    margin-top: auto;\n    margin-bottom: 0;\n  }\n\n  // Company name style\n  .company-name {\n    font-size: 28px;\n    text-align: center;\n    margin-bottom: 20px;\n    font-weight: bold;\n  }\n\n  // Receipt title\n  .receipt-title {\n    text-align: center;\n    margin-bottom: 30px;\n    \n    h1 {\n      font-size: 24px;\n      font-weight: bold;\n      color: #004A9A;\n      margin: 0;\n      padding: 10px;\n      border: 2px solid #004A9A;\n      display: inline-block;\n      letter-spacing: 2px;\n    }\n  }\n\n  // Two-column layout for receipt details and client info\n  .receipt-details-container {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    gap: 30px;\n    width: 100%;\n\n    .receipt-info,\n    .client-info {\n      flex: 1;\n      max-width: 50%;\n\n      h3 {\n        font-size: 16px;\n        font-weight: bold;\n        margin-bottom: 10px;\n        color: #333;\n        border-bottom: 2px solid #004A9A;\n        padding-bottom: 5px;\n        width: 100%;\n      }\n    }\n\n    .receipt-info {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      padding-right: 15px;\n      margin-right: 0;\n    }\n\n    .client-info {\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      padding-left: 15px;\n      margin-left: 0;\n      min-width: 0;\n\n      h3 {\n        text-align: left;\n      }\n\n      p {\n        width: 100%;\n        word-wrap: break-word;\n      }\n    }\n  }\n\n  // Payment details section\n  .payment-details-section {\n    margin: 20px 0;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n\n    h3 {\n      font-size: 18px;\n      font-weight: bold;\n      margin-bottom: 15px;\n      color: #004A9A;\n      border-bottom: 2px solid #004A9A;\n      padding-bottom: 5px;\n    }\n\n    .payment-details-table {\n      width: 100%;\n      border-collapse: collapse;\n\n      td {\n        padding: 8px 12px;\n        border-bottom: 1px solid #eee;\n        font-size: 14px;\n\n        &:first-child {\n          width: 40%;\n          background-color: #f5f5f5;\n          font-weight: 500;\n        }\n\n        &:last-child {\n          width: 60%;\n        }\n\n        &.amount-cell {\n          font-weight: bold;\n          color: #004A9A;\n          font-size: 16px;\n        }\n      }\n\n      tr:last-child td {\n        border-bottom: none;\n      }\n    }\n  }\n\n  // Invoice summary section\n  .invoice-summary {\n    margin: 20px 0;\n    border: 1px solid #004A9A;\n    border-radius: 8px;\n    background-color: #f0f7ff;\n\n    h3 {\n      font-size: 18px;\n      font-weight: bold;\n      margin-bottom: 15px;\n      color: #004A9A;\n      border-bottom: 2px solid #004A9A;\n      padding-bottom: 5px;\n    }\n\n    .invoice-summary-table {\n      width: 100%;\n      border-collapse: collapse;\n\n      td {\n        padding: 10px 12px;\n        border-bottom: 1px solid #ddd;\n        font-size: 14px;\n\n        &:first-child {\n          width: 60%;\n          font-weight: 500;\n        }\n\n        &:last-child {\n          width: 40%;\n          text-align: right;\n        }\n\n        &.amount-cell {\n          font-weight: bold;\n          color: #004A9A;\n          font-size: 16px;\n        }\n      }\n\n      tr:last-child td {\n        border-bottom: none;\n        font-weight: bold;\n        background-color: #004A9A;\n        color: white;\n\n        &.amount-cell {\n          color: white;\n        }\n      }\n    }\n  }\n\n  // Amount in words\n  .amount-in-words {\n    margin: 20px 0;\n    padding: 15px;\n    background-color: #f5f5f5;\n    border-left: 4px solid #004A9A;\n    font-style: italic;\n\n    p {\n      margin: 0;\n      font-size: 14px;\n    }\n  }\n\n  // Bank details\n  .bank-details {\n    margin: 15px 0;\n    padding: 15px;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n\n    strong {\n      display: block;\n      margin-bottom: 5px;\n      font-size: 16px;\n      color: #004A9A;\n    }\n\n    p {\n      margin: 5px 0;\n      line-height: 1.6;\n    }\n  }\n\n  // Receipt footer section\n  .receipt-footer-section {\n    margin-top: 30px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n\n    .signature {\n      text-align: left;\n      flex: 1;\n\n      img {\n        width: 150px;\n        height: auto;\n        margin-bottom: 10px;\n      }\n\n      p {\n        margin: 0;\n        font-size: 12px;\n        font-style: italic;\n        color: #666;\n      }\n    }\n\n    .generated-info {\n      text-align: right;\n      flex: 1;\n\n      p {\n        margin: 5px 0;\n        font-size: 12px;\n        color: #666;\n\n        &:last-child {\n          font-weight: bold;\n          color: #004A9A;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  // Paragraph styles\n  .receipt-info p,\n  .client-info p,\n  .bank-details p {\n    margin: 4px 0;\n    font-size: 14px;\n\n    strong {\n      font-weight: bold;\n    }\n  }\n\n  @media print {\n    width: 100%;\n    margin: 0;\n    padding: 20px;\n\n    .receipt-header,\n    .receipt-footer {\n      max-width: 100%;\n      page-break-inside: avoid;\n    }\n\n    .payment-details-section,\n    .invoice-summary,\n    .bank-details,\n    .receipt-footer-section {\n      page-break-inside: avoid;\n    }\n\n    .receipt-details-container {\n      page-break-inside: avoid;\n    }\n  }\n\n  // Responsive design for smaller screens\n  @media (max-width: 768px) {\n    .receipt-details-container {\n      flex-direction: column;\n      gap: 20px;\n\n      .receipt-info {\n        padding-right: 0;\n        border-bottom: 1px solid #e0e0e0;\n        padding-bottom: 15px;\n      }\n\n      .client-info {\n        padding-left: 0;\n        padding-top: 15px;\n      }\n    }\n\n    .receipt-footer-section {\n      flex-direction: column;\n      align-items: center;\n      gap: 20px;\n\n      .signature,\n      .generated-info {\n        text-align: center;\n      }\n    }\n  }\n\n  // Ensure proper spacing and avoid orphans\n  * {\n    box-sizing: border-box;\n  }\n\n  p,\n  div,\n  section {\n    orphans: 2;\n    widows: 2;\n  }\n\n  // Force content to stay together when possible\n  .receipt-info,\n  .client-info,\n  .payment-details-section,\n  .invoice-summary,\n  .bank-details,\n  .receipt-footer-section {\n    page-break-inside: avoid;\n  }\n}\n\n.req-pad {\n  padding: 0.8rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
